import React from "react";
import {render} from "react-dom";
// import StorePicker from "./components/StorePicker";
// import App from "./components/App";
import Router from  "./components/Router";
// import NotFound from  "./components/NotFound";
// the above got moved to Router.js 
import "./css/style.css";
render(<Router/>, document.querySelector("#main"));


// WEBPACK FOOTER //
// ./src/index.js